<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="addContact">
            <van-loading
                class="pageLogin"
                v-if="isloading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                title="添加"
                left-text="通讯录"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <div class="list">
                    <van-sidebar
                        class="van_left"
                        v-model="activeKey"
                        v-if="isOrganization"
                    >
                        <template v-for="(item, index) in organizationData">
                            <van-sidebar-item
                                v-if="item.type >= organizationPower"
                                :title="item.name"
                                :key="index"
                                @click="selectOrganization(item.type)"
                            ></van-sidebar-item>
                        </template>
                    </van-sidebar>
                    <van-index-bar
                        class="van_left addContactList van-pull-refresh"
                        v-if="departmentData.length>0"
                        :index-list="indexList"
                        :sticky="false"
                    >
                        <template v-for="(item, index) in departmentData">
                            <van-index-anchor :index="item.Initial" :key="index"></van-index-anchor>
                            <template v-for="(k, i) in item.data">
                                <van-cell :key="i" is-link @click="openContactInfo(k.id)">
                                    <span class="van_left">{{ k.icon }}</span>
                                    <p v-if="k.org_shortname != 'null' && k.org_shortname != null && k.org_shortname != ''" class="van_left">
                                        {{ k.org_shortname }}
                                    </p>
                                    <p v-else class="van_left">
                                        {{ k.org_name }}
                                    </p>
                                </van-cell>
                            </template>
                        </template>
                    </van-index-bar>
                    <p class="noData van_left" v-else>
                        暂无数据
                    </p>
                </div>
            </section>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 添加联系人
    name: 'add-contact',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'add-contact');
        }
        next();
    },
    props: {},
    data() {
        return {
            // 加载中状态
            isloading: false,
            // 组织机构默认下标
            activeKey: 0,
            // 组织机构数据
            organizationData: [
                {
                    name: '集团',
                    type: '1',
                },
                {
                    name: '运营区',
                    type: '2',
                },
                {
                    name: '片区',
                    type: '3',
                },
                {
                    name: '经济体',
                    type: '4',
                },
                {
                    name: '平台公司',
                    type: '5',
                },
                {
                    name: '分公司',
                    type: '6',
                },
                {
                    name: '场站',
                    type: '7',
                },
            ],
            // 是否显示组织机构
            isOrganization: false,
            // 组织机构权限
            organizationPower: 0,
            // 当前选择组织type
            organizationType: 0,
            // 当前组织id
            organizationId: '',
            // 组织下部门数据
            departmentData: [],
            // 索引数组
            indexList: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        this.gitOrganizationData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 打开联系人
        openContactInfo(id) {
            this.$router.isBack = 2;
            this.$router.push({ path: '/contacts', query: { id: id } });
        },
        // 切换组织
        selectOrganization(index) {
            // 当前选择组织type
            this.organizationType = index;
            this.gitDepartmentData();
        },
        // 获取当前用户组织机构数据
        gitOrganizationData() {
            this.$axios
                .get('/interfaceApi/basicplatform/orgtree/parent/all2/' + this.$takeTokenParameters('TreeId'))
                .then(res => {
                    if (res) {
                    // 组织机构权限, 判断显示哪些组织
                        this.organizationPower = res.org_type;
                        // 当前选择组织type
                        this.organizationType = res.org_type;
                        // 当前选择组织id
                        this.organizationId = res.org_id;
                        // 默认加载第一个组织下的部门数据
                        this.gitDepartmentData();
                    }
                }).catch(error => {
                    this.isloading = false;
                    this.$dialog({ message: error });
                });
        },
        // 获取组织下部门数据
        gitDepartmentData() {
            this.isloading = false;
            this.$axios
                .get('/interfaceApi/basicplatform/orgtree/orgtype/' + this.organizationId + '/' + this.organizationType + '?page=1&row=9999')
                .then(res => {
                    if (res.List.length > 0) {
                        // 处理数据
                        const newData = this.$dataSorting(res.List, 'org_name');
                        // 常用联系人数据赋值
                        this.departmentData = newData.dataList;
                        // 索引数组赋值
                        this.indexList = newData.indexList;
                    } else {
                        this.departmentData = [];
                    }
                    this.isOrganization = true;
                    this.isloading = false;
                }).catch(error => {
                    this.isloading = false;
                    this.$dialog({ message: error });
                });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus">
.addContact
    height 100%
    section
        height calc(100% - 44rpx)
        .list
            height 100%
            overflow hidden
            .van-sidebar
                width 75rpx
                height 100%
                background #F4F7FD
                .van-sidebar-item
                    background #F4F7FD
                    border-bottom 1px solid #FFFFFF
                    padding 0
                    line-height 45rpx
                    text-align center
                    font-size 14rpx
                    color #979EA7
                    border-left none
                    &.van-sidebar-item--select
                        color #E60000
                        background #fff
            .van-index-bar
                width calc(100% - 75rpx)
                position relative
                .van-cell
                    height 50rpx
                    padding 10rpx 30rpx 10rpx 15rpx
                    line-height 30rpx
                    &:after
                        left 0
                    span
                        width 30rpx
                        height 30rpx
                        background #3595FA
                        border-radius 50%
                        margin-right 15rpx
                        font-size 18rpx
                        text-align center
                        line-height 32rpx
                        color #fff
                    p
                        font-size 16rpx
                        color #333333
                        width calc(100% - 45rpx)
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    .van-icon
                         line-height 30rpx
                .van-index-anchor
                    background #F9F9F9
            .addContactList
                height 100%
                overflow-y scroll
                -webkit-overflow-scrolling: touch;
            .noData
                font-size 50rpx
                line-height 300rpx
                color #ccc
                text-align center
                width calc(100% - 75rpx)
</style>